import {UserLevel} from '@netx/core-user-next/constants';

export const PROJECT_REVIEWS_VIEW_MINIM_USER_LEVEL = UserLevel.BROWSER;

export enum ProjectReviewPref {
	ENABLED = 'review.enabled',
}
